// Converted from application/views/commissions_v.php. Edit this component directly.
export default function CommissionsPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/mother&child-marble"}>
<img src={"/assets/images/milestones/mother-and-child-carrara-marble-florence.jpg"} alt={"2022 “Mother and Child”,in Cararra marble, at Museo Degli Innocenti, Florence"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1 style={{"marginBottom":"3rem"}}>{"Commissions"}</h1>
<h2>{"2022"}</h2>
<h1>{"“Mother and Child”, Carrara Marble, Museo degli Innocenti, Florence"}</h1>
</div>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/commissions/life-and-death-vicchio.jpg"} alt="" />
</figure>
<div class={"text"}>
<div>
<h3>{"2019"}</h3>
<h2>{"\n                “Life and Death” Memorial to victims of war and terrorism, Vicchio, Tuscany\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/milestones/the-day-that-changed-ireland-sculpture-ireland.jpg"} alt={"2015 “The Day That Changed Ireland”,Rugby sculpture at Shannon Airport, Ireland"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2015"}</h3>
<h2>{"\n                “The Day That Changed Ireland” Rugby sculpture at Shannon Airport, Ireland\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/milestones/official-sculpture-portrait-mary-mcaleese-president-of-ireland.jpg"} alt={"2011 Official Portrait of Mary McAleese, President of Ireland(1997-2011)"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2011"}</h3>
<h2>{"\n                Official Portrait of Mary McAleese, President of Ireland (1997 – 2011)\n            "}</h2>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/milestones/spirit-of-love-statue.jpg"} alt={"2006 “Spirit of Love” Memorial, Bantry Bay, Cork"} />
</figure>
<div class={"text"}>
<div>
<h3>{"2006"}</h3>
<h2>{"\n                “Spirit of Love” Memorial to all those lost at sea in Bantry Bay,  Co. Cork. Ireland\n            "}</h2>
</div>
</div>
</div>
</>;
}
